import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { ErrorService, NotificationService, UserService } from '../../shared/services';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { TokenUtilities } from './token.utilities';
import {
  interceptRefreshingRequest,
  interceptRequestWithoutAuthHeader,
  sendRequest,
  TokenInterceptorDeps,
} from './token-interceptor.helpers';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const deps: TokenInterceptorDeps = {
    authService: inject(AuthService),
    userService: inject(UserService),
    notificationService: inject(NotificationService),
    errorService: inject(ErrorService),
  };

  if (TokenUtilities.isItRefreshingRequest(request)) {
    return interceptRefreshingRequest(deps, request, next);
  }

  if (TokenUtilities.isItRequestWithoutAuthHeader(request)) {
    return interceptRequestWithoutAuthHeader(deps, request, next);
  }

  return sendRequest(deps, request, next);
};
